module.exports = { "default": require("core-js/library/fn/observable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/observable.js
// module id = 528
// module chunks = 0